import * as globalActions from 'partner-portal-actions'
import { SIGN_IN_ROUTE } from 'config'
import * as routerActions from 'react-router-redux'

export function signOut() {
  return function (dispatch) {
    dispatch(clearDetails())
    dispatch(routerActions.replace(SIGN_IN_ROUTE))
  }
}

export function clearDetails() {
  return function (dispatch) {
    dispatch(globalActions.setAuthenticated({ token: null }))
    dispatch(globalActions.setIsAdmin(false))
    dispatch(globalActions.setCurrentPartnerId(null))
    dispatch(globalActions.clearPartner())
  }
}
